export default __webpack_public_path__ + "static/media/Block_M-Hex.a22e7e3e.png";